import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationDopplerFindingsDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationDopplerFindings/GetDetail?` + params, null);

export const GetRefOBGyExaminationDopplerFindingsList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationDopplerFindings/GetList?` + params, null);

export const CreateRefOBGyExaminationDopplerFindings = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationDopplerFindings/Create`, data);

export const UpdateRefOBGyExaminationDopplerFindings = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationDopplerFindings/Update`, data);

export const DeleteRefOBGyExaminationDopplerFindings = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationDopplerFindings/Delete`, data);